<template>
  <v-app id="inspire" >
    <v-content class="content">
      <v-container
        fluid
      >
        <v-row
          align="start"
          justify="center"
          class="pa-0"
        >
          <v-col
            cols="10"
            sm="6"
            md="5"
            lg="4"
            xl="4"
            class="pa-0 mt-0"
          >
            <div class = "title-container">
              <v-list-item >
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class="headline mb-1">
                    <v-icon id="icon-style" size="2.4vh">fas fa-clouds</v-icon>
                  </v-list-item-title>
                  <v-list-item-subtitle class ="icon-subtitle">multicloud</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item >
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class ="login-title ma-0 pa-0">Reset password</v-list-item-title>
                  <v-list-item-subtitle class="ma-0 pa-0">
                    <hr class="underscore">
                  </v-list-item-subtitle>
                  <p class="login-subtitle">PSC Multicloud Platform</p>
                </v-list-item-content>
              </v-list-item>
            </div>
            <v-form @submit.prevent="onConfirm">
              <v-card class="elevation-0 pl-2 pr-2 pb-0 pt-0 ma-0" color="rgba(255, 0, 0, 0)">
                <v-card-text class="justify-center pr-2 pl-2 pb-0 pt-0">
                    <v-text-field
                      class="code"
                      :class="{'code': !errors && $v.credentials.code.required,
                      'email-error': errors && !$v.credentials.code.required }"
                      placeholder="Verification code"
                      name="code"
                      type="text"
                      rounded
                      hide-details
                      solo
                      flat
                      height="50px"
                      v-model="credentials.code"
                      :error="errors && !$v.code.required"
                    ></v-text-field>
                    <v-text-field
                      class="password"
                      :class="{'password': !errors && $v.credentials.password.required,
                      'password-error': errors && !$v.credentials.password.required }"
                      name="password"
                      type="password"
                      placeholder="New password"
                      rounded
                      solo
                      flat
                      hide-details
                      height="50px"
                      v-model="credentials.password"
                      :error="errors && !$v.credentials.password.required"
                    >
                     <v-tooltip slot="append" max-width="16vw" right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">
                            fas fa-question
                        </v-icon>
                      </template>
                      <span>Your password must:</span>
                      <ul>
                        <li>have at least 8 characters</li>
                        <li>contain at least one uppercase letter</li>
                        <li>contain at least one number digit</li>
                        <li>contain at least one special character</li>
                      </ul>
                      </v-tooltip>
                    </v-text-field>
                    <v-text-field
                      class="confirm-password"
                      :class="{'confirm-password': !errors && $v.credentials.confirmPassword.required && $v.credentials.confirmPassword.sameAsPassword,
                      'confirm-password-error': errors && !$v.credentials.confirmPassword.required || !$v.credentials.confirmPassword.sameAsPassword}"  
                      name="confirmPassword"
                      type="password"
                      placeholder="Confirm new password"
                      :error-messages="!$v.credentials.confirmPassword.sameAsPassword && !loading ? 'The passwords you entered do not match' : null"
                      rounded
                      solo
                      flat
                      height="50px"
                      v-model="credentials.confirmPassword"
                      :error="errors && !$v.credentials.confirmPassword.sameAsPassword"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="justify-center mt-0 pt-0">
                  <v-btn
                    id="confirm"
                    class="text-none mb-0 pb-0"
                    type="submit" 
                    rounded
                    min-height="50px"
                    height="50px"
                    max-height="50px"
                    :disabled="errors || $v.credentials.$invalid"
                  >
                  <v-icon id="spinner" medium center v-if="loading">fas fa-spinner fa-spin</v-icon>
                  <span v-else>Confirm</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import ErrorSnackbar from "./ErrorSnackbar";

import { required, sameAs } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      credentials: {
        email: "",
        code: "",
        password: "",
        confirmPassword: ""
      },
      errors: false,
      loading: false
    };
  },
  mixins: [validationMixin],
  computed: mapGetters(["emailAddress"]),
  validations: {
    credentials: {
      code: { required },
      password: { required },
      confirmPassword: { sameAsPassword: sameAs("password") }
    }
  },
  methods: {
    ...mapActions(["forgotPasswordSubmit"]),
    async onConfirm() {
      if (this.$v.$invalid) {
        this.errors = true;
      } else {
        this.loading = true;
        this.credentials.code = this.credentials.code.trim();
        await this.forgotPasswordSubmit(this.credentials);
        this.loading = false;
        

        this.$router.push('/login');

        this.clearData();
      }
    },
    clearData() {
      this.credentials = {
        password: "",
        code: "",
        confirmPassword: "",
        email: ""
      };
    }
  },
  components: {
    ErrorSnackbar
  },
  created() {
    if(!this.emailAddress) 
      this.$router.push("/login");
    else
      this.credentials.email = this.emailAddress;
  }
};
</script>

<style scoped>
.content {
  background-image: url("../../assets/casestudies-banner.png");
  background-size: cover;
}

.password .v-input__slot {
  background-color: #ffffff;
  font: 1.2rem "Montserrat";
}

.confirm-password .v-input__slot {
  background-color: #ffffff;
  font: 1.2rem "Montserrat";
}

.code .v-input__slot {
  background-color: #ffffff;
  font: 1.2rem "Montserrat";
}

#confirm {
  background-color: #6db42c;
  color: #ffffff !important;
  width: 100%;
  font: 1.2rem "Montserrat";
  transition: all 0.2s ease;
  border-radius: 12vw;
}

#confirm:focus::before {
  opacity: 0 !important;
}

.title-container {
  text-align: center;
  margin-bottom: 6.5vh;
  margin-top: 2vh !important;
}

#icon-style {
  color: #ffffff !important;
  margin-top: 0.3vh !important;
}

.icon-subtitle {
  color: #ffffff !important;
  margin-bottom: 8vh;
  font: bold 1rem "Montserrat";
}

.login-title {
  color: #ffffff !important;
  font: Bold 2.3rem "Montserrat";
}

.login-subtitle {
  color: #ffffff !important;
  font: 1rem "Montserrat";
}

.underscore {
  background-color: #6db42c;
  border: 0.2vh solid #6db42c;
  border-radius: 0.2vh;
  width: 3vw;
  margin: auto;
  margin-top: 1.6vh;
  margin-bottom: 3vh;
}

#spinner {
  color: white !important;
}

.code >>> .v-input__control {
  min-height: auto !important;
  border-radius: 12vw !important;
  margin-bottom: 4%;
  font: 1rem "Montserrat";
}

.password >>> .v-input__control {
  min-height: auto !important;
  border-radius: 12vw !important;
  margin-bottom: 4%;
  font: 1rem "Montserrat";
}

.confirm-password >>> .v-input__control {
  min-height: auto !important;
  border-radius: 12vw !important;
  margin-bottom: 3%;
  font: 1rem "Montserrat";
}
</style>